import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { Modal } from "@a2z/ui";
import { LogoForm } from "@/modules/settings/components/LogoForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  logoUrl: string | null;
};

export function BrandingLogoSheet({ isOpen, onClose, logoUrl }: Props) {
  const t = useTranslations();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t(keys.seller.storeLogoTitle)}
      closeLabel={t(keys.common.cancel)}
      hideFooter
    >
      <LogoForm logoUrl={logoUrl} />
    </Modal>
  );
}
